import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { TaskModalService } from '../task-modal.service';
import { TaskBase } from 'src/api';
import { AsyncPipe } from '@angular/common';
import { PriorityComponent } from '../../priority/priority.component';
import { IconV2Module, FileUploadV2Module } from '@schenck/rotec-components';
import { DateComponent } from '../../date/date.component';
import { StatusComponent } from '../../status/status.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

export interface TaskModalMainHeaderItem {
  /**
   * Is put into the th element and translated.
   */
  name: string;
  /**
   * Is put into the td element and is not translated.
   */
  value: string;
}

@Component({
  selector: 'ma-task-modal-main',
  templateUrl: './task-modal-main.component.html',
  styleUrls: ['./task-modal-main.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PriorityComponent,
    IconV2Module,
    DateComponent,
    StatusComponent,
    TranslatePipe,
    TranslateDirective,
    AsyncPipe,
    FileUploadV2Module,
  ],
})
export class TaskModalMainComponent<Task extends TaskBase> {
  public taskModalService = inject<TaskModalService<Task>>(TaskModalService);

  /**
   * Additional task information that should be shown in the header.
   */
  @Input()
  public taskInfos: TaskModalMainHeaderItem[][] = [];
  /**
   * Picture id of the asset associated to the task.
   */
  @Input()
  public assetPictureId: string;
}
